import { LoadingOverlay } from '@airtm/airtm-ui';
import ApolloNetworkStatus from 'components/ApolloNetworkStatus/ApolloNetworkStatus';
import Notifications from 'containers/Notifications/Notifications';
import SessionContainer from 'containers/SessionContainer/SessionContainer';
import SignupOrLoginContainer from 'containers/SignupOrLoginContainer/SignupOrLoginContainer';
import TranslationsContainer from 'containers/TranslationsContainer';
import MinimalNotifications from 'containers/MinimalNotifications/MinimalNotifications';
import { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet';
import { Route, Switch, useLocation } from 'react-router-dom';
import Invitation from 'screens/Invitation/Invitation';
import useCleanAndValidateQueryParams from 'utils/hooks/useCleanAndValidateQueryParams';

const Layout = lazy(() => import(/* webpackChunkName: "Layout" */ 'screens/Layout/Layout'));
const ServerError = lazy(
  () => import(/* webpackChunkName: "ServerError" */ 'screens/ServerError/ServerError'),
);
const PromotionOptInScreen = lazy(
  () =>
    import(
      /* webpackChunkName: "PromotionOptInScreen" */ 'screens/PromotionOptInScreen/PromotionOptInScreen'
    ),
);

const Routes = function () {
  const { state } = useLocation();
  const { skipAppBanner } = state || {};
  useCleanAndValidateQueryParams();

  return (
    <SessionContainer>
      <TranslationsContainer>
        <ApolloNetworkStatus />
        <Notifications />
        <Suspense fallback={<LoadingOverlay />}>
          <Helmet defaultTitle="Airtm - Get Paid Better" titleTemplate="Airtm - %s" />

          <Switch>
            <Route
              path="/login"
              render={() => <SignupOrLoginContainer skipAppBanner={skipAppBanner} />}
            />
            <Route
              path="/sign-up/sent"
              exact
              render={() => <SignupOrLoginContainer skipAppBanner={skipAppBanner} />}
            />
            <Route
              path="/sign-up"
              render={() => <SignupOrLoginContainer skipAppBanner={skipAppBanner} />}
            />
            <Route
              path="/forgot-password"
              render={() => <SignupOrLoginContainer skipAppBanner />}
            />
            <Route
              path="/recover-password"
              render={() => <SignupOrLoginContainer skipAppBanner />}
            />
            <Route path="/promotion-opt-in" component={PromotionOptInScreen} />
            <Route path="/ivt/:code" component={Invitation} />
            <Route exact path="/500" component={ServerError} />
            <Route path="/" component={Layout} />
          </Switch>
        </Suspense>
        <MinimalNotifications />
      </TranslationsContainer>
    </SessionContainer>
  );
};

export default Routes;
